import { useCallback, useEffect, useRef, useState } from 'react';
import * as d3 from 'd3';

const useZoom = () => {
  const rootGRef = useRef(null);
  const svgRef = useRef(null);
  const zoomRef = useRef(null);
  const zoomTransformRef = useRef(null);

  const [isZoomEnabled, setIsZoomEnabled] = useState(false);

  const zoomIn = useCallback(() => {
    if (zoomRef.current) {
      const svg = d3.select(svgRef.current);
      svg.style('pointer-events', 'all').transition().call(zoomRef.current.scaleBy, 1.25);
    }
  }, []);

  const resetZoom = useCallback(() => {
    if (zoomRef.current) {
      const svg = d3.select(svgRef.current);
      svg.style('pointer-events', 'all').transition().call(zoomRef.current.transform, d3.zoomIdentity);
    }
  }, []);

  const zoomOut = useCallback(() => {
    if (zoomRef.current) {
      const svg = d3.select(svgRef.current);
      svg.style('pointer-events', 'all').transition().call(zoomRef.current.scaleBy, 0.8);
    }
  }, []);

  const handleZoomStart = () => {
    const svg = d3.select(svgRef.current);
    svg.style('cursor', 'grabbing');
  };

  const handleZoomEnd = () => {
    const svg = d3.select(svgRef.current);
    svg.style('cursor', 'grab');
  };

  const handleZoom = (event) => {
    const rootG = d3.select(rootGRef.current);

    zoomTransformRef.current = event.transform;
    rootG.attr('transform', event.transform);
  };

  const initializeZoom = useCallback(() => {
    zoomRef.current = d3.zoom().on('zoom', handleZoom).on('start', handleZoomStart).on('end', handleZoomEnd);
  }, []);

  const setupZoom = useCallback(() => {
    if (zoomRef.current && isZoomEnabled) {
      const svg = d3.select(svgRef.current);
      svg.call(zoomRef.current).call(zoomRef.current.transform, zoomTransformRef.current || d3.zoomIdentity);
    }
  }, [isZoomEnabled]);

  const switchOnZoom = useCallback(() => {
    if (zoomRef.current) {
      const svg = d3.select(svgRef.current);
      svg.call(zoomRef.current).call(zoomRef.current.transform, zoomTransformRef.current || d3.zoomIdentity);
    }
  }, []);

  useEffect(() => {
    const handleClick = () => {
      setIsZoomEnabled(true);
      switchOnZoom();
    };

    if (svgRef.current) {
      svgRef.current.addEventListener('click', handleClick);
    }
  }, [switchOnZoom]);

  return {
    rootGRef,
    svgRef,
    zoomIn,
    resetZoom,
    zoomOut,
    initializeZoom,
    setupZoom,
  };
};

export default useZoom;
